import { Parser } from "hot-formula-parser";

const parser = new Parser();

export function processFormula(formula: string, row: { [columnId: string]: any }): any {
    const substitutedFormula = formula.replace(/{(.+?)}/g, (match, group) => {
        return row[group] !== undefined ? row[group] : `""`;
    });
    const result =  parser.parse(substitutedFormula);
    if (result.error) {
        console.log(`Error parsing formula "${formula}", "${substitutedFormula}": ${result.error}`);
        return undefined;
    }

    return result.result;
}
